//
// GroupingInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/BIRDModel";
import "./DataItemInfo";
import "./ValueGroup";

var GroupingInfo = createModule("BIRD::GroupingInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        sourceItemInfo: 1,
        valueGroups: [1],
    },
    ,
    ,
    ,
    ,
    ,
]);
export default GroupingInfo;
